import { render, staticRenderFns } from "./AsAMasterPage.vue?vue&type=template&id=16cce27c&scoped=true"
import script from "./AsAMasterPage.vue?vue&type=script&setup=true&lang=js"
export * from "./AsAMasterPage.vue?vue&type=script&setup=true&lang=js"
import style0 from "./AsAMasterPage.vue?vue&type=style&index=0&id=16cce27c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16cce27c",
  null
  
)

export default component.exports